import React, { useEffect, useContext, useState } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Alert,
  Input as FormInput,
} from "reactstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faShoppingCart,
  faAnchor,
  faShip,
  faBagShopping,
} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { Icon } from "@mdi/react";
import { mdiMagnify } from "@mdi/js";

import {
  addItemToBookmark,
  getBookmark,
} from "../../api/BookMarks/BookmarkApi.js";
import { addItemToCart } from "../../api/Cart/AddcartApi.js";
import {
  getPlants,
  getProccesingCostByPlantId,
  getProcessingCostsByIdandType,
} from "../../api/processing plant/plantApi.js";
import { getCouriers } from "../../api/courier/courierApi.js";
import { AuthContext } from "../../pages/ExtraPages/AuthProvider";
import "./cartModel.css";

const StockListPage = ({ stockData, showOutOfStockMessage }) => {
  const [showOutOfStockMessage2, setShowOutOfStockMessage2] = useState(
    showOutOfStockMessage
  );
  const [quantities, setQuantities] = useState({});
  const [bookmarkedItems, setBookmarkedItems] = useState({});
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [formData, setFormData] = useState({
    processingPlant: "",
    processingType: [],
    courier: "",
    quantity: "",
  });
  const [plants, setPlants] = useState([]);
  const [processingTypes, setProcessingTypes] = useState([]);
  const [couriers, setCouriers] = useState([]);
  const [usdPrices, setUsdPrices] = useState({}); // New state for USD prices

  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const lastPathSegment = pathParts[pathParts.length - 1];
  const { user } = useContext(AuthContext);
  const [userId, setUserId] = useState(null);
  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const speciesMap = {
    "Albacore": "alb",
    "Southern-bluefin-tuna": "sbt",
    "Big-eye-tuna": "bet",
    "Yellowfin-tuna": "yft",
    "Long-tail-tuna": "ltt",
    "Skip-jack-tuna": "sjt",
    "Kawa-kawa": "kk",
    "Frigate-tuna": "ft",
    "Bullet-tuna": "bt",
    "Narrow-barred-spanish-mackerel": "nbsm",
    "Indo-pacific-king-mackerel": "ipkm",
    "Wahoo": "wh",
    "Oil-fish": "of",
    "Escolar": "esc",
    "Common-dolphinfish": "cdf",
    "Great-barracuda": "gb",
    "Rainbow-runner": "rr",
    "Rough-trigger-fish": "rtf",
    "Atlantic-pomfret": "ap",
  };

  function getFishIdByName(name) {
    return speciesMap[name] || null; // returns null if key not found
  }
  // Function to fetch exchange rate and convert LKR to USD
  const fetchExchangeRate = async (lkrAmount) => {
    try {
      const response = await fetch(
        "https://open.exchangerate-api.com/v6/latest/USD"
      );
      const data = await response.json();
      if (data.result === "success") {
        const lkrRate = data.rates.LKR; // Exchange rate for 1 USD in LKR
        const usdAmount = lkrAmount / lkrRate; // Convert lkrAmount to USD
        return usdAmount.toFixed(2); // Return value rounded to 4 decimal places
      } else {
        throw new Error("API request failed");
      }
    } catch (err) {
      throw new Error("Failed to fetch exchange rate");
    }
  };

  useEffect(() => {
    if (!user) return;
    setUserId(user.uid);
  }, [user]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const plantsResponse = await getPlants();
        const couriersResponse = await getCouriers();
        setPlants(plantsResponse.data || []);
        setCouriers(couriersResponse.data.data || []);
      } catch (error) {
        console.error("Error fetching initial data:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load processing plants or couriers.",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    };
    fetchInitialData();
  }, []);

  useEffect(() => {
    const fetchProcessingTypes = async () => {
      if (formData.processingPlant) {
        
        try {
          const response = await getProcessingCostsByIdandType(
            formData.processingPlant,
            getFishIdByName(formData.Product_Name)
          );
          console.log("Processing types response:", response);
          setProcessingTypes(response.data || []);
        } catch (error) {
          console.error("Error fetching processing types:", error);
          setProcessingTypes([]);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to load processing types.",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      } else {
        setProcessingTypes([]);
      }
    };
    fetchProcessingTypes();
  }, [formData.processingPlant]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        // Fetch bookmarks
        if (userId && stockData?.length) {
          stockData.forEach((item) => {
            fetchBookmarkData(userId, item._id);
          });
        }
        // Fetch USD prices for each stock item's Price_per_Kg
        if (stockData?.length) {
          const pricePromises = stockData.map(async (item) => {
            try {
              const usdPrice = await fetchExchangeRate(item.Price_per_Kg);
              return { id: item._id, usdPrice };
            } catch (err) {
              console.error(`Error converting price for ${item._id}:`, err);
              return { id: item._id, usdPrice: "N/A" };
            }
          });
          const priceResults = await Promise.all(pricePromises);
          const newUsdPrices = priceResults.reduce(
            (acc, { id, usdPrice }) => ({
              ...acc,
              [id]: usdPrice,
            }),
            {}
          );
          setUsdPrices(newUsdPrices);
        }
      } catch (error) {
        console.error("Error in fetchData:", error);
      } finally {
        setTimeout(() => setLoading(false), 1000);
      }
    };
    fetchData();
  }, [userId, stockData]);

  const fetchBookmarkData = async (userId, itemId) => {
    try {
      const response = await getBookmark(userId, itemId);
      const data = response.data;
      setBookmarkedItems((prev) => ({
        ...prev,
        [itemId]: data.status === "active",
      }));
    } catch (error) {
      setBookmarkedItems((prev) => ({
        ...prev,
        [itemId]: false,
      }));
      console.error("Error fetching bookmark data:", error);
    }
  };

  const handleBookmark = async (stock_id) => {
    const addData = {
      userId: userId,
      itemId: stock_id,
      status: bookmarkedItems[stock_id] ? "inactive" : "active",
    };

    try {
      const response = await addItemToBookmark(addData);
      const data = response.data;
      setBookmarkedItems((prev) => ({
        ...prev,
        [stock_id]: data.status === "active",
      }));
      Swal.fire({
        icon: data.status === "active" ? "success" : "warning",
        title: data.status === "active" ? "Bookmark added" : "Bookmark removed",
        text:
          data.status === "active"
            ? "The item has been added to your bookmarks."
            : "The item has been removed from your bookmarks.",
        showConfirmButton: false,
        timer: 1500,
        position: "top-end",
        toast: true,
        background: "#333",
        color: "#fff",
        timerProgressBar: true,
      });
    } catch (error) {
      console.error("Error updating bookmark:", error);
    }
  };

  const toggleModal = () => {
    setModal(!modal);
    if (modal) {
      setFormData({
        processingPlant: "",
        processingType: [],
        courier: "",
        quantity: "",
      });
      setProcessingTypes([]);
    }
  };

  const handleCartClick = (quantity, productId) => {
    const product = stockData.find((item) => item._id === productId);
    setSelectedProduct(product);
    setFormData({
      Product_Name: product.Product_Name,
      processingPlant: "",
      processingType: [],
      courier: "",
      quantity: quantity || product?.Minimum_Order_Quantity || 1,
    });
    toggleModal();
  };

  const handleFormChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === "processingType") {
      setFormData((prev) => {
        const newProcessingTypes = checked
          ? [...prev.processingType, value]
          : prev.processingType.filter((type) => type !== value);
        const totalProcessingFee = newProcessingTypes.reduce((sum, type) => {
          const processingType = processingTypes.find(
            (pt) => pt.processingType === type
          );
          return (
            sum +
            (processingType ? parseFloat(processingType.processingFee || 0) : 0)
          );
        }, 0);
        return {
          ...prev,
          processingType: newProcessingTypes,
          processingFee: totalProcessingFee,
        };
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ...(name === "processingPlant"
          ? { processingType: [], processingFee: 0 }
          : {}),
      }));
    }
  };

  const handleFormSubmit = async () => {
    if (
      !formData.processingPlant ||
      formData.processingType.length === 0 ||
      !formData.courier ||
      !formData.quantity
    ) {
      Swal.fire({
        icon: "error",
        title: "Incomplete Form",
        text: "Please fill in all fields, including at least one processing type.",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    if (
      parseFloat(formData.quantity) > selectedProduct.Total_Available_Quantity
    ) {
      Swal.fire({
        icon: "error",
        title: "Invalid Quantity",
        text: `Quantity cannot exceed available stock (${selectedProduct.Total_Available_Quantity} kg).`,
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    const payload = {
      User_id: userId,
      Stock_id: selectedProduct._id,
      Weight: parseFloat(formData.quantity),
      Processing_Plant: formData.processingPlant,
      Processing_Type: formData.processingType,
      Courier: formData.courier,
      Courier_Fee: 0,
      Processing_Fee: formData.processingFee,
    };

    console.log("Payload for adding to cart:", payload);

    try {
      const response = await addItemToCart(payload);
      if (response.data.status === 1) {
        Swal.fire({
          icon: "warning",
          title: "Already Added",
          text: "This item has already been added.",
          timer: 900,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Successfully Added",
          text: "The item has been successfully added.",
          timer: 900,
          showConfirmButton: false,
        });
      }
      toggleModal();
    } catch (error) {
      console.error("Error adding to cart:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while adding to cart.",
        timer: 900,
        showConfirmButton: false,
      });
    }
  };

  const handleChange = (e, minQuantity, itemId) => {
    const newQuantity = Math.max(minQuantity, e.target.value);
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [itemId]: newQuantity,
    }));
  };

  const filteredStockData = stockData;

  if (loading) {
    return (
      <Row className="justify-content-left">
        {Array.from({ length: 8 }).map((_, index) => (
          <Col lg={3} md={6} key={index} className="">
            <div className="col-sm-12">
              <div className="card stock-card">
                <div className="overlay-boat stock-card-inner">
                  <div
                    style={{
                      width: "100%",
                      height: "240px",
                      backgroundColor: "#ccc",
                      borderRadius: "4px",
                      position: "relative",
                      overflow: "hidden",
                    }}
                    className="shimmer"
                  />
                  <div className="ps-4">
                    <div
                      style={{
                        width: "60%",
                        height: "12px",
                        backgroundColor: "#ccc",
                        marginTop: "15px",
                        borderRadius: "4px",
                        position: "relative",
                        overflow: "hidden",
                      }}
                      className="shimmer"
                    />
                    <div className="d-flex">
                      <div
                        style={{
                          width: "40%",
                          height: "20px",
                          backgroundColor: "#ccc",
                          marginTop: "10px",
                          borderRadius: "4px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                        className="shimmer"
                      />
                      <div>&nbsp;</div>
                      <div
                        style={{
                          width: "40%",
                          height: "20px",
                          backgroundColor: "#ccc",
                          marginTop: "10px",
                          borderRadius: "4px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                        className="shimmer"
                      />
                    </div>
                  </div>
                  <div className="card-body">
                    <div
                      style={{
                        width: "80%",
                        height: "25px",
                        backgroundColor: "#ccc",
                        marginBottom: "10px",
                        borderRadius: "4px",
                        position: "relative",
                        overflow: "hidden",
                      }}
                      className="shimmer"
                    />
                  </div>
                </div>
              </div>
            </div>
            <style jsx>{`
              .shimmer::before {
                content: "";
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(
                  90deg,
                  transparent,
                  rgba(255, 255, 255, 0.4),
                  transparent
                );
                animation: shimmer 0.9s infinite;
              }

              @keyframes shimmer {
                0% {
                  transform: translateX(-100%);
                }
                100% {
                  transform: translateX(100%);
                }
              }
            `}</style>
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <>
      <style>
        {`
          .rounded-checkbox {
            display: none;
          }
          .rounded-checkbox-label {
            display: inline-block;
            padding: 8px 16px;
            margin: 5px;
            border: 2px solid #ccc;
            borderRadius: 20px;
            cursor: pointer;
            transition: all 0.3s ease;
            background-color: #f8f9fa;
            font-size: 14px;
          }
          .rounded-checkbox-label:hover {
            background-color: #e9ecef;
          }
          .rounded-checkbox:checked + .rounded-checkbox-label {
            background-color: #007bff;
            color: white;
            border-color: #007bff;
          }
        `}
      </style>
      <Row className="justify-content-left">
        {showOutOfStockMessage && visible && (
          <div style={{ margin: '10px' }}>
            <Alert
              color="warning"
              isOpen={visible}
              toggle={onDismiss}
              style={{
                position: 'relative',
                right: '10px',
                zIndex: 1000,
                padding: '10px',
                borderRadius: '5px',
              }}
            >
              The selected fish type is currently out of stock. Displaying all
              available fish types.
            </Alert>
          </div>
        )}
        <br />
        <br />

        {filteredStockData.length === 0 ? (
          <div className="no-result-container">
            <Icon
              path={mdiMagnify}
              size={4.6}
              color="#777777"
              style={{ marginRight: '8px' }}
            />
            <h2>No Results</h2>
            <p>We're sorry. We cannot find any matches for your search term.</p>
          </div>
        ) : (
          filteredStockData.map((item, key) => (
            <Col
              xs={6} // 👈 This ensures 2 columns per row on mobile (6 + 6 = 12)
              md={6}
              lg={3}
              key={key}
            >
              <div className="col-sm-12">
                <div className="card stock-card">
                  <div className="overlay-boat stock-card-inner">
                    <img
                      src={item.Vessel_Thumb}
                      className="card-img-top stock-card-img"
                      alt="Product"
                      width="100%"
                    />
                    {userId && (
                      <span
                        className="favorite-icon"
                        style={{ border: 'none' }}
                      >
                        <Link onClick={() => handleBookmark(item._id)}>
                          <i
                            className={`uil uil-heart${
                              bookmarkedItems[item._id] ? '' : '-alt'
                            }`}
                            style={{
                              color: bookmarkedItems[item._id]
                                ? '#fff'
                                : 'gray',
                              background: bookmarkedItems[item._id]
                                ? 'red'
                                : 'transparent',
                              fontSize: '18px',
                              width: '28px',
                              height: '28px',
                              cursor: 'pointer',
                              borderRadius: '50%',
                              transition: 'all 0.3s ease',
                              border: 'none',
                            }}
                          ></i>
                        </Link>
                      </span>
                    )}
                    <Button
                      className="cart-button"
                      // style={{
                      //   background: 'transparent',
                      //   border: '1px solid white',
                      //   color: 'rgb(47.6, 124.1, 200.6)',
                      //   position: 'absolute',
                      //   width: '40px',
                      //   height: '40px',
                      //   borderRadius: '50%',
                      //   right: '20px',
                      //   bottom: '20px',
                      //   backdropFilter: 'blur(10px)',
                      // }}
                      onClick={() =>
                        handleCartClick(
                          quantities[item.Product_Name] ||
                            item.Minimum_Order_Quantity,
                          item._id
                        )
                      }
                    >
                      <FontAwesomeIcon
                        icon={faShoppingCart}
                        className="cart-icon"
                        // style={{
                        //   color: 'white',
                        //   position: 'absolute',
                        //   left: '11px',
                        //   top: '12px',
                        // }}
                      />
                    </Button>
                    {item.Total_Available_Quantity > 0 ? (
                      <div
                        className="d-flex flex-column bag-shipping"
                        // style={{
                        //   position: 'absolute',
                        //   left: '20px',
                        //   bottom: '20px',
                        //   border: '1px solid white',
                        //   borderRadius: '40px',
                        //   background: 'transparent',
                        //   padding: '5px 10px',
                        //   color: 'white',
                        //   backdropFilter: 'blur(10px)',
                        // }}
                      >
                        <div className="d-flex flex-row">
                          <div className="d-flex flex-column ml-1">
                            <span className="ml-1 body-regular">
                              <FontAwesomeIcon icon={faBagShopping} />{' '}
                              {item.Total_Available_Quantity} kg
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex flex-column"
                        style={{
                          position: 'absolute',
                          left: '20px',
                          bottom: '20px',
                          padding: '5px 10px',
                          color: 'white',
                        }}
                      >
                        <span className="badge bg-warning text-white">
                          Out of Stock
                        </span>
                      </div>
                    )}
                  </div>
                  <div
                    style={{ paddingTop: '10px' }}
                    className="card-body"
                  >
                    <Link
                      to={`/stockdetails/${item._id}`}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      <div>
                        <span
                          className="body-small-medium fish-name"
                          style={{ paddingTop: '0px', paddingLeft: '0px' }}
                        >
                          {item.Product_Name}
                        </span>
                      </div>
                    </Link>
                    <div>
                      <div
                        className="harbour-and-boat"
                        style={{ paddingTop: '10px', color: 'grey' }}
                      >
                        <div className="d-flex flex-row">
                          <FontAwesomeIcon icon={faAnchor} />
                          <div>
                            <span
                              style={{
                                paddingLeft: '10px',
                                top: '-3px',
                                position: 'relative',
                              }}
                            >
                              {item.Harbour}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex flex-row">
                          <FontAwesomeIcon icon={faShip} />
                          <div>
                            <span
                              style={{
                                paddingLeft: '10px',
                                top: '-3px',
                                position: 'relative',
                              }}
                            >
                              {item.Boat_Number}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-row justify-content-between mid">
                      <div className="d-flex flex-column">
                        <div className="price-row">
                          <span className="ml-1 subtitle-bold">
                            LKR {item.Price_per_Kg}/kg{' '}
                          </span>
                          <span className="d-price">
                            {usdPrices[item._id] &&
                            usdPrices[item._id] !== 'N/A'
                              ? `(USD ${usdPrices[item._id]}/kg)`
                              : '(USD N/A)'}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-3">
                      <Link
                        to={`/stockdetails/${item._id}`}
                        className="btn btn-sm btn-outline-primary w-100"
                        style={{
                          borderRadius: '8px',
                          padding: '8px 16px',
                          fontSize: '14px',
                          fontWeight: '500',
                          transition: 'all 0.3s ease',
                        }}
                      >
                        More Details
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))
        )}
      </Row>

      <Modal
        isOpen={modal}
        toggle={toggleModal}
        centered
        fade
        className="cart-add-modal"
      >
        <ModalHeader toggle={toggleModal}>
          Add to Cart - {selectedProduct?.Product_Name}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="processingPlant">Processing Plant</Label>
              <FormInput
                type="select"
                name="processingPlant"
                id="processingPlant"
                value={formData.processingPlant}
                onChange={handleFormChange}
              >
                <option value="">Select Processing Plant</option>
                {plants.map((plant) => (
                  <option
                    key={plant.userId}
                    value={plant.userId}
                  >
                    {plant.companyName}
                  </option>
                ))}
              </FormInput>
            </FormGroup>
            <FormGroup>
              <Label for="processingType">Processing Types</Label>
              <div>
                {processingTypes.length === 0 && formData.processingPlant && (
                  <p>Loading processing types...</p>
                )}
                {processingTypes.map((type, index) => (
                  <div
                    key={index}
                    style={{ display: 'inline-block' }}
                  >
                    <FormInput
                      type="checkbox"
                      name="processingType"
                      id={`processingType-${index}`}
                      value={type.processingType}
                      checked={formData.processingType.includes(
                        type.processingType
                      )}
                      onChange={handleFormChange}
                      className="rounded-checkbox"
                    />
                    <label
                      htmlFor={`processingType-${index}`}
                      className="rounded-checkbox-label"
                    >
                      {`${type.processingType} (LKR ${type.processingFee}/kg)`}
                    </label>
                  </div>
                ))}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="courier">Courier</Label>
              <FormInput
                type="select"
                name="courier"
                id="courier"
                value={formData.courier}
                onChange={handleFormChange}
              >
                <option value="">Select Courier</option>
                {couriers.map((courier) => (
                  <option
                    key={courier._id}
                    value={courier.userId}
                  >
                    {courier.companyName}
                  </option>
                ))}
              </FormInput>
            </FormGroup>
            <FormGroup>
              <Label for="quantity">Quantity (kg)</Label>
              <FormInput
                type="number"
                name="quantity"
                id="quantity"
                value={formData.quantity}
                onChange={handleFormChange}
                min={selectedProduct?.Minimum_Order_Quantity || 1}
                max={selectedProduct?.Total_Available_Quantity || 1000}
                step="0.1"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleFormSubmit}
          >
            Add to Cart
          </Button>
          <Button
            color="secondary"
            onClick={toggleModal}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default StockListPage;
